import React, { useEffect, useState } from "react";
import SectionHeader from "../../components/SectionHeader";
import HeaderImage from "../../images/main-banner.png";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { selectCategory } from "../../Redux/actions/filterActions";
import ProductListing from "../../UI/ProductListing";
import ReactPaginate from "react-paginate";
import { useLocation } from "react-router-dom";
import HeaderImage2 from "../../images/banner-side -image.png";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";

const Shop = () => {
  const [categories, setCategories] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [selectedPriceRange, setSelectedPriceRange] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const itemsPerPage = 16;
  const [pageCount, setPageCount] = useState(0);
  const selectedCategory = useSelector((state) => state.shop.selectedCategory);
  const location = useLocation();
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const baseUrl = process.env.REACT_APP_BASE_URL;
        const response = await axios.get(`${baseUrl}/api/show-products`, {
          params: {
            page: pageNumber + 1,
            per_page: itemsPerPage,
            category: selectedCategory || "",
          },
        });
        if (response.data.data && response.data.data) {
          setProductsData(response.data.data);
          setPageCount(response.data.last_page);
        } else {
          console.error(
            "Expected a data property but got:",
            response.data.data
          );
          setProductsData([]);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
        setProductsData([]);
      }
      setLoading(false);
    };

    fetchProducts();
  }, [pageNumber, selectedCategory]);

  useEffect(() => {
    const fetchAllCategories = async () => {
      try {
        const baseUrl = process.env.REACT_APP_BASE_URL;
        const response = await axios.get(`${baseUrl}/api/all-categories`);
        const formattedCategories = response.data.map((category, index) => ({
          id: index + 1,
          category,
        }));
        setCategories(formattedCategories);
      } catch (error) {
        console.error("Error fetching all categories:", error);
      }
    };

    fetchAllCategories();
  }, []);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const baseUrl = process.env.REACT_APP_BASE_URL;
        const response = await axios.get(`${baseUrl}/api/brands`);
        setBrands(response.data);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };

    fetchBrands();
  }, []);

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const query = searchParams.get("search");
    setSearchQuery(query || "");
  }, [location]);

  const handleCategorySelect = (category) => {
    dispatch(selectCategory(category));
    setPageNumber(0);
  };

  const handlePriceRangeChange = (priceRange) => {
    setSelectedPriceRange(priceRange);
  };

  const filterProductsByPriceRange = (products) => {
    if (!selectedPriceRange) {
      return products;
    }
    const [minPrice, maxPrice] = selectedPriceRange
      .split("-")
      .map((price) => parseFloat(price.slice(1)));
    return products.filter((product) => {
      const productPrice = parseFloat(product.price.replace("$", ""));
      return productPrice >= minPrice && productPrice <= maxPrice;
    });
  };

  const filterProductsByCategory = (products) => {
    if (!selectedCategory) {
      return products;
    }
    return products.filter((product) => product.category === selectedCategory);
  };

  const filterProductsBySearchQuery = (products) => {
    if (!searchQuery) {
      return products;
    }
    const searchQueryLowerCase = searchQuery.toLowerCase();
    return products.filter(
      (product) =>
        (product.slug &&
          product.slug.toLowerCase().includes(searchQueryLowerCase)) ||
        (product.category &&
          product.category.toLowerCase().includes(searchQueryLowerCase)) ||
        (product.brand_id + "").toLowerCase().includes(searchQueryLowerCase)
    );
  };
  const getItemsToDisplay = () => {
    const sortedAndFilteredProducts = filterProductsByPriceRange(
      filterProductsByCategory(productsData)
    );
    const searchFilteredProducts = filterProductsBySearchQuery(
      sortedAndFilteredProducts
    );
    return searchFilteredProducts.filter(
      (product) => product.quote_product !== "request_quote"
    );
  };

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
  };

  const handleBrandSelect = async (brandId) => {
    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const response = await axios.get(
        `${baseUrl}/api/show-products/brand/${brandId}`
      );
      setProductsData(response.data); // Update the products based on the selected brand
      setPageNumber(0); // Reset to the first page
    } catch (error) {
      console.error("Error fetching products by brand:", error);
    }
  };

  return (
    <>
      <section className="shop-main-page">
        <SectionHeader
          title="SHOP"
          image={HeaderImage}
          image2={HeaderImage2}
          title2="Detail About Vendor"
        // content=""
        ></SectionHeader>
        <Container fluid>
          <div className="shop_detail_main ">
            {/* <div className="brandclasss"> */}
            <Row>

              <Col xs={4} sm={4} md={3} lg={3}>
                <div className="sidebar">
                  <div className="category">
                    <h5 className="categories">BRANDS</h5>
                    <div className="category-list">
                      {brands.map((brand) => (
                        <button
                          key={brand.brand_id}
                          className="category_btn"
                          onClick={() => handleBrandSelect(brand.brand_id)}
                        >
                          {brand.name}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="category">
                    <h5 className="categories">CATEGORIES</h5>
                    <div className="category-list">
                      {categories.map(({ id, category }) => (
                        <button
                          key={id}
                          className="category_btn"
                          onClick={() => handleCategorySelect(category)}
                        >
                          {category}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="category">
                    <h5 className="price-range">PRICE RANGE</h5>
                    <ul className="price__range">
                      <li>
                        <input
                          type="checkbox"
                          name="$5-$10"
                          onChange={() => handlePriceRangeChange("$5-$10")}
                        />
                        <div className="price-span">
                          <span>$5</span>-<span>$10</span>
                        </div>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="$10-$15"
                          onChange={() => handlePriceRangeChange("$10-$15")}
                        />
                        <div className="price-span">
                          <span>$10</span>-<span>$15</span>
                        </div>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="$15-$25"
                          onChange={() => handlePriceRangeChange("$15-$25")}
                        />
                        <div className="price-span">
                          <span>$15</span>-<span>$25</span>
                        </div>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          name="$25-$50"
                          onChange={() => handlePriceRangeChange("$25-$50")}
                        />
                        <div className="price-span">
                          <span>$25</span>-<span>$50</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>

              <Col xs={8} sm={8} md={9} lg={9}>
                <div className="products">
                  {loading ? (
                    <div className="text-center">Loading products...</div>
                  ) : getItemsToDisplay().length > 0 ? (
                    <Row>
                      <ProductListing sortedProducts={getItemsToDisplay()} />
                    </Row>
                  ) : (
                    <div className="alert alert-warning" role="alert">
                      No products found.
                    </div>
                  )}
                </div>
              </Col>

            </Row>

            <ReactPaginate
              previousLabel={<FaArrowLeft />}
              nextLabel={<FaArrowRight />}
              pageCount={pageCount} // Use the updated pageCount here
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
            />
          </div>
        </Container>
      </section >
    </>
  );
};

export default Shop;
